/*-----------------------------------------------------------------------------/
/ Custom Theme JS
/-----------------------------------------------------------------------------*/

// const text_spoiler_tpl = document.createElement('template')
//   text_spoiler_tpl.innerHTML = `
//     <div class="wr">
//       <div class="content">
//        <slot></slot>
//       </div>
//       <button class="show" aria-expanded="false"> Show More </button>
//     </div>
//     <style>
//       .wr[open="false"] .content {
//         max-height: 130px;
//         position: relative;
//         overflow: hidden;
//       }

//       .wr[open="false"] .content:before {
//         content: '';
//         position: absolute;
//         display: block;
//         left: 0px;
//         right: 0px;
//         bottom: 0px;
//         height: 75px;
//         background: linear-gradient(180deg, #ffffff 0%, rgb(0 0 0 / 0%) 100%);
//         transform: rotate(180deg);
//         transition: all 0.5s;
//       }

//       .show {
//         all: unset;
//         text-decoration: underline
//       }

//       .show:hover {
//         cursor: pointer
//       }
//     </style>
//   `

//   class TextSpoiler extends HTMLElement {

//     constructor () {
//       super()

// 			if (this.offsetHeight <= 300) {
// 				return
// 			}

//       this.setAttribute('role', 'region')
//       this.attachShadow({ mode: 'open' })
//       this.shadowRoot.appendChild(text_spoiler_tpl.content.cloneNode(true))

//       let btn = this.shadowRoot.querySelector('button')
//       let wr = this.shadowRoot.querySelector('.wr')

//       btn.onclick = () => {
//         let open = this.getAttribute('open') === 'true' || false
//         this.setAttribute('open', open ? 'false' : 'true')
//         wr.setAttribute('open', open ? 'false' : 'true')
//         open ? btn.innerText = 'Show more' : btn.innerText = 'Show less'
//       }

// 			wr.setAttribute('open', false )
//     }
//   }

//   customElements.define('text-spoiler', TextSpoiler)


const text_spoiler_tpl = document.createElement('template')
    text_spoiler_tpl.innerHTML = `
      <div class="wr">
        <div class="content">
        <slot></slot>
        </div>
        <button class="show" aria-expanded="false"> Show More </button>
      </div>
      <style>
        .wr {
          display: block;
          height: 100%;
        }
        .wr .content {
          min-height: calc(100% - 65px);
        }
        .wr[open="false"] .content {
          max-height: 100px;
          position: relative;
          overflow: hidden;
        }

        .wr[open="false"] .content:before {
          content: '';
          position: absolute;
          display: block;
          left: 0px;
          right: 0px;
          bottom: 0px;
          height: 70px;
          background: linear-gradient(180deg, #ffffff 0%, rgb(0 0 0 / 0%) 100%);
          transform: rotate(180deg);
          transition: all 0.5s;
        }

        .wr[open="true"] .content {
          padding-bottom: 1rem;
        }

        .show {
          all: unset;
          font-weight: 500;
          font-size: calc(var(--font-size-base) - 2px);
          transition: color 0.3s ease, background 0.3s ease, border-color 0.3s ease, box-shadow 0.3s ease, opacity 0.3s ease;
        }

        .show:hover {
          cursor: pointer;
          color: var(--theme-primary-colours-primary)
        }
        @media screen and (max-width: 900px) {
          .wr {
            height: unset;
          }
        }
      </style>
    `

  class TextSpoiler extends HTMLElement {

    constructor () {
      super()
      this.bind(this)
    }

    bind(el) {
      el.render = el.render.bind(el)
      el.attachEvents = el.attachEvents.bind(el)
      el.onSpoilerClick = el.onSpoilerClick.bind(el)
    }

    connectedCallback() {
      this.render()
      this.attachEvents()
    }

    render() {
      this.setAttribute('role', 'region')
      this.shadow = this.attachShadow({ mode: "open"})
      this.shadowRoot.appendChild(text_spoiler_tpl.content.cloneNode(true))
      let h = this.getBoundingClientRect().height
      if(h > 300) {
        this.shadowRoot.querySelector('.wr').setAttribute('open', false )
      } else {
        this.shadowRoot.querySelector('button').style.display = "none";
      }
    }

    attachEvents() {
      if(this.shadowRoot.querySelector('button')) {
        this.shadowRoot.querySelector('button').addEventListener('click', this.onSpoilerClick)
      }
    }

    onSpoilerClick(e) {
      let open = this.getAttribute('open') === 'true' || false
      this.setAttribute('open', open ? 'false' : 'true')
      this.shadowRoot.querySelector('.wr').setAttribute('open', open ? 'false' : 'true')
      open ? e.target.innerText = 'Show more' : e.target.innerText = 'Show less'
    }
  }

  customElements.define('text-spoiler', TextSpoiler)

  class VooTabPanel extends HTMLElement {
    static observedAttributes = ["selected-index", "direction"];
    #selectedIndex = 0;
    #direction = "row";
    constructor() {
        super();
        this.bind(this);
    }
    bind(element) {
        element.render = element.render.bind(element);
        element.attachEvents = element.attachEvents.bind(element);
        element.cacheDom = element.cacheDom.bind(element);
        element.onTabClick = element.onTabClick.bind(element);
        element.selectTabByIndex = element.selectTabByIndex.bind(element);
        element.onContentSlotChange = element.onContentSlotChange.bind(element);
        element.onTabSlotChange = element.onTabSlotChange.bind(element);
    }
    connectedCallback() {
        this.render();
        this.cacheDom();
        this.attachEvents();
        this.dom.tabs[this.#selectedIndex]?.classList.add("selected");
        this.dom.contents[this.#selectedIndex]?.classList.add("selected");
    }
    render() {
        this.shadow = this.attachShadow({ mode: "open" });
        this.shadow.innerHTML = `
                <style>
                    :host { display: flex; flex-direction: column; }
                    :host([direction="column"]) { flex-direction: row; }
                    :host([direction="column"]) .tabs { flex-direction: column; }
                    .tabs { display: flex; flex-direction: row; flex-wrap: nowrap; gap: var(--tab-gap, 0px); justify-content: center; }
                    .tabs ::slotted(*) {

                     }
                    .tabs ::slotted(.selected) { background: #efefef; }
                    .tab-contents ::slotted(*) { display: none; }
                    .tab-contents ::slotted(.selected) { display: block; }

                    .tab-contents {
                      background: #FFFFFF;
                      border: 0.5px solid #FCC8A7;
                      border-radius: 20px;
                      padding: 20px
                    }

                    @media screen and (max-width: 600px) {
                      .tab-contents {
                        border-radius: 0px 0px 20px 20px;
                      }
                    }

                    @media screen and (max-width: 425px) {
                      .tabs {
                        align-items: stretch;
                      }
                    }

                </style>
                <div class="tabs">
                    <slot id="tab-slot" name="tab"></slot>
                </div>
                <div class="tab-contents">
                    <slot id="content-slot" name="content" ></slot>
                </div>
            `;
    }
    cacheDom() {
        this.dom = {
            tabSlot: this.shadow.querySelector("#tab-slot"),
            contentSlot: this.shadow.querySelector("#content-slot")
        };
        this.dom.tabs = this.dom.tabSlot.assignedElements();
        this.dom.contents = this.dom.contentSlot.assignedElements();
    }
    attachEvents() {
        this.dom.tabSlot.addEventListener("click", this.onTabClick);
        this.dom.tabSlot.addEventListener("slotchange", this.onTabSlotChange);
        this.dom.contentSlot.addEventListener("slotchange", this.onContentSlotChange);
    }
    onTabSlotChange(){
        this.dom.tabs = this.dom.tabSlot.assignedElements();
    }
    onContentSlotChange(){
        this.dom.contents = this.dom.contentSlot.assignedElements();
    }
    onTabClick(e) {
        const target = e.target;
        if (target.slot === "tab") {
            const tabIndex = this.dom.tabs.indexOf(target);
            this.selectTabByIndex(tabIndex);
        }
    }
    selectTabByIndex(index) {
        const tab = this.dom.tabs[index];
        const content = this.dom.contents[index];
        if (!tab || !content) return;
        this.dom.contents.forEach(p => p.classList.remove("selected"));
        this.dom.tabs.forEach(p => p.classList.remove("selected"));
        content.classList.add("selected");
        tab.classList.add("selected");
    }
    attributeChangedCallback(name, oldValue, newValue) {
        if (oldValue !== newValue) {
            if(name === "selected-index"){
                this.selectedIndex = newValue;
            } else {
                this[name] = newValue;
            }
        }
    }
    set selectedIndex(value) {
        this.#selectedIndex = value;
    }
    get selectedIndex() {
        return this.#selectedIndex;
    }
    set direction(value){
        this.#direction = value;
        this.setAttribute("direction", value);
    }
    get direction(){
        return this.#direction;
    }
  }

  customElements.define("voo-tab-panel", VooTabPanel);
